import React from "react";

// Authoritative HMC brand mark — the uploaded crowned-anchor crest, framed
// in a crisp white badge so it reads cleanly on navy surfaces.
export const BrandMark = ({ className = "h-11 w-11" }) => (
  <div
    className={`${className} rounded-xl bg-white shadow-md ring-1 ring-gold-500/30 shrink-0`}
    style={{
      backgroundImage: "url(/hmc-logo-full.png)",
      backgroundSize: "150%",
      backgroundPosition: "center 20%",
      backgroundRepeat: "no-repeat",
    }}
    role="img"
    aria-label="Hussar Marine Concierge"
  />
);

export default BrandMark;
